export const COMPETITOR_PLAYER_STATS = {
  ACTION_TYPES: {
    onPlayerChange: 'onPlayerChange',
    statsScrolledHandler: 'statsScrolledHandler',
    statsDisplayHandler: 'statsDisplayHandler',
    statsPlayerScrollHandler: 'statsPlayerScrollHandler',
    athleteLineupFetch: 'athleteLineupFetch',
    onButtonClick: 'onButtonClick',
    onShotSelected: 'onShotSelected',
    onGoalViewExpanded: 'onGoalViewExpanded',
    tabChange: 'tabChange',
    shotMapShotClick: 'shotMapShotClick',
    shotMapShowMoreClick: 'shotMapShowMoreClick',
    shotMapShotSwipeClick: 'shotMapShotSwipeClick',
    tabClick: 'tabClick'
  },

  TABS: {
    INDEXES:{
      heatMap: 0,
      shotMap: 1
    },

    ANALYTIC_NAMES: {
      heatMap: 'heat-map',
      shotMap: 'shot-map',
    }
  },

  SHOT_CHARTS_OFFSET: {
    COURT_WITHOUT_OUTLINES: 0.92,
    HALF_COURT_SIDE: 2,

    COURT_RATIO: {
      football: 1.58,
      basketball: 1.1
    },

    COURT_DIVIDER: 100
  },

  DIRECTION: {
    prev: 'prev',
    next: 'next'
  },

  CLICK_TYPE: {
    playerDetails: 'players-details',
    gameDetails: 'game-details',
    close: 'close'
  },

  SELECTOR_CLICK_TYPE: {
    more: 'show-more',
    less: 'show-less'
  },

  DESIGN: {
    COMPETITOR_LOGO_SIZE: {
      desktop: 24,
      mobile: 20,
    },

    CAROUSEL_CONTAINER_SIZES: {
      desktop: 122,
      mobile: 114,
    },

    PLAYER_LOGO_SIZE: {
      desktop: 62,
      mobile: 54,
    },

    TOP_STATS_ICON_SIZE: {
      mobile: 24,
      desktop: 34
    },

    EMPTY_STATE_IMAGE_SIZES: {
      DESKTOP: {
        width: 140,
        height: 69
      },

      MOBILE: {
        width: 98,
        height: 49
      }
    }
  }
};